import { Camera, Video } from "lucide-react";

/** Pastilles « nombre de photos / vidéo » posées sur l'image principale d'une annonce. */
export const BadgesMedias = ({ nbPhotos = 0, aVideo = false, testid, decale = false }) => {
  if (nbPhotos < 1 && !aVideo) return null;
  return (
    <div
      className={`absolute right-2.5 z-10 flex flex-col items-end gap-1.5 ${decale ? "top-12" : "top-2.5"}`}
      data-testid={testid}
    >
      {nbPhotos > 0 && (
        <span
          data-testid={`${testid}-photos`}
          className="inline-flex items-center gap-1.5 rounded-xl bg-black/65 px-2 py-1 text-xs font-bold text-white backdrop-blur-sm"
        >
          <Camera size={13} /> {nbPhotos}
        </span>
      )}
      {aVideo && (
        <span
          data-testid={`${testid}-video`}
          className="inline-flex items-center gap-1.5 rounded-xl bg-black/65 px-2 py-1 text-xs font-bold text-white backdrop-blur-sm"
        >
          <Video size={13} /> 1
        </span>
      )}
    </div>
  );
};

export default BadgesMedias;
